// EXAMPLE METHOD CALL

export const api_postal_codes = async ({url, devmode, id, method, verb}) => {

    const verb_url = `/api?verb=${verb}`

      return fetch(url + verb_url, {
        credentials:"same-origin",
        method,
        headers: {
          'Accept': 'application/json',
        }
      }).then(async (result) => {
        const data = await result.json()
        console.log('API DATA CALL', data)
        return await data
          
      }).catch((error) => {
          // DO SOMETHING ON ERROR
          console.log('ERROR ON API CALL', error)
          return false
      })
  }
  
  export const api_get_directories = async ({url, devmode, id, name, verb, data}) => {

    const verb_url = `/api?verb=${verb}&id=${id}&name=${name}`

      return fetch(url + verb_url, {
        credentials: "same-origin",
        headers: {
          'Accept': 'application/json',
        }
      }).then(async (result) => {
        const result_data = await result.json()
        console.log('API DIRECTORIES FOR POSTAL CODE', result_data)
        return await result_data
          
      }).catch((error) => {
          // DO SOMETHING ON ERROR
          console.log('ERROR ON API CALL', error)
          return false
      })
  }


// WEBPACK FOOTER //
// ./src/api_service.js